import 'css/src/data/transcript/nodes/TrimSymbolNode.module.scss';

import type { EditorConfig, LexicalEditor, LexicalNode, SerializedTextNode, Spread } from 'lexical';
import { TextNode } from 'lexical';

import { $isTranscriptWordNode } from 'js/src/data/transcript/nodes/TranscriptWordNode';
import { $dfsIteratorWithinNode } from 'js/src/data/transcript/transcript-utils';

const TrimSymbolNodeLexicalType = 'trim-symbol-node'; // DO NOT CHANGE THIS OR ELSE OLD TRANSCRIPTS WILL NOT RENDER
export type SerializedTrimSymbolNode = Spread<
    {
        type: typeof TrimSymbolNodeLexicalType;
    },
    SerializedTextNode
>;
export class TrimSymbolNode extends TextNode {
    static override getType() {
        return TrimSymbolNodeLexicalType;
    }

    static override clone(node: TrimSymbolNode): TrimSymbolNode {
        return new TrimSymbolNode(node.__text, node.__key);
    }

    override createDOM(config: EditorConfig, editor?: LexicalEditor): HTMLElement {
        const sceneNumber = document.createElement('span');
        sceneNumber.className = 'trim-symbol';
        sceneNumber.contentEditable = 'false'; // do not allow the user to edit the scene number
        sceneNumber.textContent = this.__text;
        sceneNumber.title = this.getTitleContent();
        return sceneNumber;
    }

    override exportJSON(): SerializedTrimSymbolNode {
        return {
            ...super.exportJSON(),
            type: TrimSymbolNodeLexicalType,
        };
    }

    static override importJSON(serializedNode: SerializedTrimSymbolNode): TrimSymbolNode {
        return $createTrimSymbolNode(serializedNode.text);
    }

    override canInsertTextBefore(): boolean {
        // if the cursor is right next to the scene number node,
        // and the user begins typing, text should not go into the
        // scene number node
        return false;
    }

    override canInsertTextAfter(): boolean {
        // if the cursor is right next to the scene number node,
        // and the user begins typing, text should not go into the
        // scene number node
        return false;
    }

    getTitleContent(): string {
        let retVal = '';
        const parent = this.getParent();
        if (!parent) {
            return retVal;
        }
        for (const iteratorNode of $dfsIteratorWithinNode(parent)) {
            const node = iteratorNode.node;
            if ($isTranscriptWordNode(node)) {
                retVal += node.getTextContent();
                if (retVal.length > 100) {
                    // limit the title content to around 100 characters
                    retVal = retVal.trim() + '...';
                    break;
                }
            }
        }
        return retVal;
    }
}

export const $createTrimSymbolNode = (text: string): TrimSymbolNode => {
    return new TrimSymbolNode(text);
};

export const $isTrimSymbolNode = (node: LexicalNode): node is TrimSymbolNode => {
    return node instanceof TrimSymbolNode;
};
